window.gwpCurrentCallback = null;

var fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

async function checkGWP(cart, callback = null, callbackOnlyOnSuccess = false) {
  const { giftVariantIds, giftForcedVariantId, giftProductId, giftEnable, giftProductAvailable, minCartPrice, eligibleProductIds, eligibleProductType, onePerEligible, giftQuantity } = window.shop.giftWithPurchase;
  const asyncCart = cart ? cart : await getCart();
  const isRemoved = sessionStorage.getItem('gwp') === 'removed';
  const totalGiftQuantity = asyncCart.items.reduce((sum, { variant_id, quantity }) => giftVariantIds.includes(variant_id) ? sum + quantity : sum, 0);
  const hasFreeGift = asyncCart.items.find((item) => giftVariantIds.includes(item.variant_id) && item.properties._isGWP);
  let eligibleProductCount = 0;
  const GWPPopup = document.querySelector('gwp-popup');
  
  let isEligible;

  if (eligibleProductIds === 'all-products') {
    isEligible = (item) => !giftVariantIds.includes(item.variant_id) &&
      (
        eligibleProductType === 'subscription'
          ? item.selling_plan_allocation?.selling_plan?.id
          : eligibleProductType === 'one_time'
            ? !item.selling_plan_allocation?.selling_plan?.id
            : true
      );
  } else {
    isEligible = (item) => eligibleProductIds.includes(item.product_id) &&
      (
        eligibleProductType === 'subscription'
          ? item.selling_plan_allocation?.selling_plan?.id
          : eligibleProductType === 'one_time'
            ? !item.selling_plan_allocation?.selling_plan?.id
            : true
      );
  }

  eligibleProductCount = asyncCart.items.reduce(
    (sum, item) => isEligible(item) ? sum + item.quantity : sum,
    0
  );

  const requiredGiftQuantity = onePerEligible ? eligibleProductCount : (eligibleProductCount > 0 ? 1 : 0);

  if (
    !giftEnable || isRemoved ||
    (giftVariantIds && !giftProductAvailable)
  ) {
    if (hasFreeGift) {
      const giftProductId = asyncCart.items.find((item) => giftVariantIds.includes(item.variant_id) && item.properties._isGWP).product_id;
      cartAjaxFetch(routes.cart_change_url, giftProductId, totalGiftQuantity - giftQuantity, callback)
    } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
      callback();
    }
  } else if (
    giftEnable &&
    eligibleProductIds &&
    giftVariantIds &&
    giftProductAvailable
  ) {
        
    var cartTotalPrice = asyncCart.items.reduce((sum, item) => isEligible(item) ? sum + item.final_line_price : sum, 0);
    var cartCurrency = asyncCart.currency;
    var cartTotalPrice__US_Dollar = Currency.convert(cartTotalPrice, cartCurrency, 'USD');

    if (
      totalGiftQuantity < requiredGiftQuantity &&
      cartTotalPrice__US_Dollar >= minCartPrice
    ) {
      if (
        eligibleProductIds === 'all-products' ||
        asyncCart.items
          .map((item) => item.product_id).some((product_id) => eligibleProductIds.includes(product_id))
      ) {
        if (giftVariantIds.length > 1 && GWPPopup && !giftForcedVariantId) {
          GWPPopup.openGwpPopup(callback);
        } else {
          const giftVariantId = giftForcedVariantId ? giftForcedVariantId : giftVariantIds[0];
          cartAjaxFetch(routes.cart_add_url, giftVariantId, giftQuantity, callback, { _isGWP: true });
        }
      } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
        callback();
      }
    } else if (
      totalGiftQuantity > requiredGiftQuantity ||
      (totalGiftQuantity > 0 && cartTotalPrice__US_Dollar < minCartPrice) ||
      (asyncCart.items.length === 1 && asyncCart.items[0].quantity == 1 && hasFreeGift) ||
      (eligibleProductIds != 'all-products' && asyncCart.items
        .map((item) => item.product_id)
        .every((product_id) => product_id == giftProductId || !eligibleProductIds.includes(product_id)))
    ) {
      const giftVariantId = asyncCart.items.find((item) => giftVariantIds.includes(item.variant_id) && item.properties._isGWP)?.variant_id;
      if (!giftVariantId) callback();
      cartAjaxFetch(routes.cart_change_url, giftVariantId, totalGiftQuantity - giftQuantity, callback);
    } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
      callback();
    }
  } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
    callback();
  }
};

async function getCart() {
  const result = await fetch('/cart.json');
  if (result.status === 200) {
      return result.json();
  }
  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

function getCartSections() {
  return [
      {
          section: "main-cart-items",
          selector: "#main-cart-items",
      },
      {
          section: "main-cart-footer",
          selector: "#main-cart-footer",
      },
      {
          section: "main-cart-header",
          selector: "#main-cart-header",
      },
      {
          section: "cart-icon-bubble",
          selector: "#cart-icon-bubble",
      },
      {
          section: "main-cart-nav",
          selector: "#main-cart-nav",
      },
  ];
}

function cartAjaxFetch(url, id, quantity, callback, properties = null) {
  var body = {
    id: id.toString(),
    quantity: quantity,
    sections: getCartSections().map((s) => s.section)
  };

  if (properties) {
    body.properties = properties;
  }

  body = JSON.stringify(body);

  fetch(url, { ...fetchConfig(), ...{ body } })
  .then((response) => response.json())
  .then((response) => {
    if (response.status) return;
    callback(response);
  }).catch((e) => {
    console.error(e);
  });
}